export var FileExtension;
(function (FileExtension) {
    FileExtension["MP3"] = "MP3";
    FileExtension["WMA"] = "WMA";
    FileExtension["WAV"] = "WAV";
    FileExtension["AIFF"] = "AIFF";
    FileExtension["AIF"] = "AIF";
    FileExtension["AIFC"] = "AIFC";
    FileExtension["RAM"] = "RAM";
    FileExtension["MP4"] = "MP4";
    FileExtension["AAC"] = "AAC";
    FileExtension["M4P"] = "M4P";
    FileExtension["MSV"] = "MSV";
    FileExtension["DVF"] = "DVF";
    FileExtension["RA"] = "RA";
    FileExtension["DSS"] = "DSS";
    FileExtension["AVI"] = "AVI";
    FileExtension["MWV"] = "MWV";
    FileExtension["MPG"] = "MPG";
    FileExtension["MOV"] = "MOV";
    FileExtension["MPEG"] = "MPEG";
    FileExtension["JPEG"] = "JPEG";
    FileExtension["JPE"] = "JPE";
    FileExtension["JPG"] = "JPG";
    FileExtension["GIF"] = "GIF";
    FileExtension["PNG"] = "PNG";
    FileExtension["WMV"] = "WMV";
    FileExtension["TIFF"] = "TIFF";
    FileExtension["TIF"] = "TIF";
    FileExtension["DOC"] = "DOC";
    FileExtension["DOT"] = "DOT";
    FileExtension["DOCX"] = "DOCX";
    FileExtension["PDF"] = "PDF";
    FileExtension["TXT"] = "TXT";
    FileExtension["RTF"] = "RTF";
    FileExtension["XLS"] = "XLS";
    FileExtension["XLSX"] = "XLSX";
    FileExtension["XLM"] = "XLM";
    FileExtension["XLA"] = "XLA";
    FileExtension["XLC"] = "XLC";
    FileExtension["XLT"] = "XLT";
    FileExtension["XLW"] = "XLW";
    FileExtension["M4A"] = "M4A";
    FileExtension["MPGA"] = "MPGA";
    FileExtension["MP2"] = "MP2";
    FileExtension["MP2A"] = "MP2A";
    FileExtension["M2A"] = "M2A";
    FileExtension["M3A"] = "M3A";
    FileExtension["EML"] = "EML";
    FileExtension["MIME"] = "MIME";
    FileExtension["MSG"] = "MSG";
    FileExtension["CSV"] = "CSV";
    FileExtension["MIE"] = "MIE";
    FileExtension["ZIP"] = "ZIP";
})(FileExtension || (FileExtension = {}));
//# sourceMappingURL=FileExtension.js.map